import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AwaitModules, ModuleFE_AppConfig, SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { ConfigKeyFE_FHIRQueryResources } from './consts.js';
export const DropDown_FHIRQueryResource = (props) => {
    return _jsx(AwaitModules, { modules: [ModuleFE_AppConfig], children: _jsx(DD_Impl, { ...props }) });
};
const DD_Impl = (props) => {
    const resources = ConfigKeyFE_FHIRQueryResources.get() ?? [];
    const adapter = SimpleListAdapter(resources.map(r => r.resource), node => _jsx(_Fragment, { children: node.item }));
    return _jsx(TS_DropDown, { adapter: adapter, selected: props.selected, onSelected: props.onSelected });
};
//# sourceMappingURL=ui-components.js.map